import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Navigate back in-app when there is a previous entry to return to, otherwise
 * open the fallback route. The initial history entry has the key `default`, so
 * a deep link does not send the user out of the app.
 */
export const useGoBack = (fallback: string = "/") => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (location.key !== "default") {
      navigate(-1);
      return;
    }
    navigate(fallback, { replace: true });
  }, [fallback, location.key, navigate]);
};

export default useGoBack;
